(function (angular) {
    angular
        .module('one.admin')
        .controller('AddContentModuleModalController', AddContentModuleModalController);

    AddContentModuleModalController.$inject = ['$scope', '$uibModalInstance', 'session','ModuleService', 'params'];

    function AddContentModuleModalController($scope, $uibModalInstance, session, ModuleService, params) {
        $scope.module = {
            module_instance: {content: ''}
        };

        angular.merge($scope, params);

        $scope.addContentModule = addContentModule;
        $scope.cancel = cancel;

        function addContentModule(data) {
            ModuleService.addModule(data).then(function (data) {
                $uibModalInstance.close(data);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})(angular);
